import * as types from '../actions/actionTypes';

const initialState = {
    applicationStatus: '',
}

export default (state = initialState, action) => {
    switch (action.type) {
        case types.UPDATE_CAMPAIGN_LISTS_APPLICATIONS_STATUS:
            return Object.assign({}, state, { applicationStatus : action.applicationStatus });
         case types.CLEAR_CAMPAIGN_LISTS_APPLICATIONS_STATUS:
            return Object.assign({}, state, { applicationStatus: initialState.applicationStatus });
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/CampaignListApplicationsReducer.js